import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider, useMsal } from "@azure/msal-react";
import { loginRequest, msalConfig } from "./authConfig";

import React, { useEffect } from "react";
import {
  Route,
  BrowserRouter as Router,
  Switch,
  useHistory,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "./App.css";

import Floaticons from "./function-components/Floaticons";
import Admin from "./function-components/AdminPages/Admin";
import FeedbackContent from "./function-components/Feedback/FeedbackContent";
import Footer from "./function-components/Footer";
import Navbarmenu from "./function-components/Navbarmenu";
import { PageLayout } from "./function-components/PageLayout";
import SearchNav from "./function-components/Searchnav";
import Dashboard from "./pages/Dashboard";
import FAQ from "./pages/FAQ";
import MeetTeam from "./pages/MeetTeam";
import AIAcademy from "./pages/AIAcademy";
import Home from "./pages/Home";
import ProjectMonarch from "./pages/ProjectMonarch";
import { CustomNavigationClient } from "./utils/NavigationClient";
import Sponsors from "./pages/Sponsors";
import CourseUpdation from "./function-components/CourseUpdation";
import UserMaintenance from "./function-components/UserMaintenance";
import Logs from "./function-components/Logs";
import AnalyticsPage from "./function-components/AnalyticsPage";
import Reviews from "./function-components/Reviews";
import ContactUs from "./pages/ContactUs";
import Americas from "./function-components/ATC-Cluster/Americas";
import Emeanew from "./function-components/ATC-Cluster/Emeanew";
import Apac from "./function-components/ATC-Cluster/Apac";
import AtcP from "./function-components/ATC-Cluster/AtcP";
import UploadIndustryLearningData from "./function-components/AdminPages/UploadIndustryLearningData";
import FAQNew from "./function-components/FAQNew";
import LearningCalendar from "./pages/LearningCalendar";

// import { callAnalytics } from "./Redux/AnalyticsSlice";

function doNothing() {
  console.log("doing nothing");
}

function App({ pca }) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);
  pca.setNavigationClient(navigationClient);

  doNothing();

  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <div container justifyContent="center">
          <Pages />
        </div>
      </PageLayout>
    </MsalProvider>
  );
}

function Pages() {
  const msalInstance = new PublicClientApplication(msalConfig);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

  // const analyticsCount = useSelector((state) => state.analytics.count);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   console.log(loggedInEnterpriseId, "id");
  //   if (loggedInEnterpriseId) {
  //     dispatch(callAnalytics(loggedInEnterpriseId));
  //   }
  // }, []);

  useEffect(() => {
    if (activeAccount) {
      fetchAccessToken();
    }
  }, [activeAccount]);

  const fetchAccessToken = async () => {
    if (!activeAccount)
      throw Error(
        "No active account! Verify a user has been signed in and setActiveAccount has been called.",
      );
    try {
      // console.log(activeAccount);
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: activeAccount,
      });
      const bearer = `Bearer ${response.accessToken}`;
      localStorage.setItem("token", bearer);
      // console.log("inside try block");
    } catch (error) {
      console.error("Error fetching access token:", error);
      localStorage.clear();
    }
  };
  // const path = window.location.pathname;
  // console.log(path, "pathhh");
  return (
    <>
      <Router>
        <SearchNav />
        <Switch>
          <Route exact path="/home">
            <Navbarmenu />
            <Home />
            <Floaticons />
          </Route>
          <Route exact path="/meettheteam">
            <Navbarmenu />
            <MeetTeam />
            <Floaticons />
          </Route>
          <Route exact path="/aiacademy">
            <Navbarmenu />
            <AIAcademy />
            <Floaticons />
          </Route>
          <Route exact path="/faq">
            <Navbarmenu />
            {/* <FAQ /> */}
            <FAQNew />
            <Floaticons />
          </Route>
          <Route exact path="/">
            <Navbarmenu />
            <Home />
            <Floaticons />
          </Route>
          <Route exact path="/feedback">
            <Navbarmenu />
            <FeedbackContent />
          </Route>
          <Route exact path="/admin">
            <Navbarmenu />
            <Admin />
          </Route>
          <Route exact path="/dashboard">
            <Navbarmenu />
            <Dashboard />
            <Floaticons />
          </Route>
          <Route exact path="/projectmonarch">
            <ProjectMonarch />
          </Route>
          <Route exact path="/dashboard">
            <Navbarmenu />
            <Dashboard />
            <Floaticons />
          </Route>
          <Route exact path="/sponsors">
            <Navbarmenu />
            <Sponsors />
            <Floaticons />
          </Route>
          <Route exact path="/dashboard">
            <Navbarmenu />
            <Dashboard />
            <Floaticons />
          </Route>
          <Route exact path="/courseUpdation">
            <Navbarmenu />
            <CourseUpdation />
          </Route>
          <Route exact path="/userMaintenance">
            <Navbarmenu />
            <UserMaintenance />
          </Route>
          <Route exact path="/logs">
            <Navbarmenu />
            <Logs />
          </Route>
          <Route exact path="/analytics">
            <Navbarmenu />
            <AnalyticsPage />
          </Route>
          <Route exact path="/reviews">
            <Navbarmenu />
            <Reviews />
          </Route>

          <Route exact path="/contactus">
            <Navbarmenu />
            <ContactUs />
            <Floaticons />
          </Route>
          <Route exact path="/EMEA">
            <Navbarmenu />
            <Emeanew />
            <Floaticons />
          </Route>
          <Route exact path="/Americas">
            <Navbarmenu />
            <Americas />
            <Floaticons />
          </Route>
          <Route exact path="/APAC">
            <Navbarmenu />
            <Apac />
            <Floaticons />
          </Route>
          <Route exact path="/ATC-P">
            <Navbarmenu />
            <AtcP />
            <Floaticons />
          </Route>
          <Route exact path="/LearningCalendar">
            <Navbarmenu />
            <LearningCalendar />
            <Floaticons />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </>
  );
}

export default App;
